import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full',
      'border-2 border-transparent',
      // Shadow
      'shadow-[inset_0_1px_3px_rgba(0,0,0,0.4)]',
      // Transition
      'transition-all duration-200',
      // Focus
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-biolume-cyan/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background',
      // Disabled
      'disabled:cursor-not-allowed disabled:opacity-50',
      // Unchecked
      'data-[state=unchecked]:bg-abyss-dark/80 data-[state=unchecked]:border-border/50',
      // Checked - glowing
      'data-[state=checked]:bg-biolume-cyan/30 data-[state=checked]:border-biolume-cyan/50',
      'data-[state=checked]:shadow-[0_0_10px_rgba(34,211,238,0.3),inset_0_1px_3px_rgba(0,0,0,0.3)]',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-4 w-4 rounded-full shadow-lg ring-0',
        'transition-transform duration-200',
        // Position
        'data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
        // Color
        'data-[state=unchecked]:bg-muted-foreground/60',
        'data-[state=checked]:bg-biolume-cyan data-[state=checked]:shadow-[0_0_8px_rgba(34,211,238,0.5)]'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
